/* Aelse add to bag, 2026-10-14. Runs the product form's Add to Bag in place of theme.js ProductForm, with the same
   events, plus: "Adding…" on the button; an 8 s limit on the add (the bag drawer comes back inside it, as the theme does), then a
   bag check: in the bag, the cart page; not in it, Shopify's plain add (cart page); slow or failed adds written to the
   console and named in Hotjar events. 2026-10-16 (her go "yes you can fix 1-3 on the copy"): the bag opens on the click with
   the item already in it (photo, name, price, variant, a fine moving line until Shopify confirms; 2026-10-16 20:27 her
   "can you fixed the adding issue"); the wallet buttons go in after the items have painted; on short screens the whole bag scrolls
   as one so the buttons never push the items out of view. Record: brands/aelse/shopify-theme/2026-10-14-safari-add-to-bag/_note.md */
(() => {
  if (window.aeAddToBag) return;
  window.aeAddToBag = { version: 1 };

  const LIMIT = 8000;
  const SLOW = 4000;
  const LABEL = 'Adding…';
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const now = () => performance.now();
  const round = (n) => Math.round(n);
  let knownCart = null;

  const style = document.createElement('style');
  style.textContent = '@media screen and (max-height: 700px){.cart-drawer::part(content){grid-auto-rows:auto auto auto;overflow-y:auto;overscroll-behavior-y:contain}.cart-drawer::part(body){overflow:visible}}'
    + '.cart-drawer.ae-adding>[slot=footer]{opacity:.45;pointer-events:none;transition:opacity .25s}'
    + '.cart-drawer.ae-adding.drawer--center-body::part(body){align-self:start}'
    + '.cart-drawer.ae-adding.drawer--center-body>:not([slot]):not(.cart-drawer__items){display:none}'
    + '.ae-pending .line-item__media{animation:ae-rise .35s ease-out both}'
    + '.ae-pending__line{position:relative;display:block;width:7.5rem;height:1px;margin-block-start:.5rem;overflow:hidden;background:rgb(var(--text-color)/.18)}'
    + '.ae-pending__line::after{content:"";position:absolute;inset:0;width:40%;background:rgb(var(--text-color)/.85);animation:ae-line 1.1s cubic-bezier(.45,0,.55,1) infinite}'
    + '@keyframes ae-line{from{transform:translateX(-100%)}to{transform:translateX(250%)}}'
    + '@keyframes ae-rise{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}'
    + '@media (prefers-reduced-motion:reduce){.ae-pending__line::after{animation:none;width:100%;opacity:.5}.ae-pending .line-item__media{animation:none}}';
  document.head.appendChild(style);

  // What the shopper just picked, read from the page: ReStock's product data first, the page itself as fallback.
  function pendingItem(form, variantId) {
    const product = window._ReStockConfig && _ReStockConfig.product;
    const variant = product && Array.isArray(product.variants) ? product.variants.find((v) => String(v.id) === String(variantId)) : null;
    const image = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image);
    const gallery = document.querySelector('product-gallery img, .product-gallery img');
    const title = (product && product.title) || ((document.querySelector('.product-info__title, h1') || {}).textContent || '').trim();
    const price = ((document.querySelector('.product-info__price sale-price, sale-price') || {}).textContent || '').replace(/^\s*sale price\s*/i, '').replace(/\s+/g, ' ').trim();
    const variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    let src = typeof image === 'string' ? image : (gallery && (gallery.currentSrc || gallery.src)) || '';
    if (src) src = src.replace(/([?&])width=\d+/, '$1width=240') + (/[?&]width=/.test(src) ? '' : (src.includes('?') ? '&' : '?') + 'width=240');
    return { title, price, variantTitle, src };
  }

  // The main product form only (form.id is shadowed by the hidden "id" input, so read the attribute).
  function openBagEarly(form, variantId) {
    const settings = (window.themeVariables && themeVariables.settings) || {};
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || settings.cartType !== 'drawer' || settings.pageType === 'cart' || !/^product-form-main/.test(form.getAttribute('id') || '')) return null;
    const item = pendingItem(form, variantId);
    const row = document.createElement('div');
    row.className = 'line-item ae-pending';
    row.setAttribute('aria-live', 'polite');
    row.innerHTML = (item.src ? '<img class="line-item__media" alt="" src="' + item.src.replace(/"/g, '&quot;') + '">' : '')
      + '<div class="line-item-info"><div class="v-stack justify-items-start gap-2"><div class="v-stack justify-items-start gap-1"><p></p><p class="text-subdued"></p></div>'
      + '<div class="v-stack justify-items-start gap-1"><p class="smallcaps text-subdued"></p></div><span class="ae-pending__line" role="progressbar" aria-label="Adding to your bag"></span></div></div>';
    const texts = row.querySelectorAll('p');
    texts[0].textContent = item.title;
    texts[1].textContent = item.price;
    texts[2].textContent = item.variantTitle;
    if (!item.price) texts[1].remove();
    if (!item.variantTitle) texts[2].parentElement.remove();
    let list = drawer.querySelector(':scope > .cart-drawer__items');
    if (!list) {
      list = document.createElement('div');
      list.className = 'cart-drawer__items';
      drawer.prepend(list);
    }
    list.prepend(row);
    drawer.classList.add('ae-adding');
    if (!drawer.open) drawer.show();
    return drawer;
  }

  function settleBag(drawer, keepOpen) {
    if (!drawer) return;
    drawer.classList.remove('ae-adding');
    drawer.querySelectorAll('.ae-pending').forEach((row) => row.remove());
    if (!keepOpen && drawer.open) drawer.hide();
  }

  // Hold the wallet buttons out of the new bag and put them back two frames later, after the items have painted.
  function holdWallets(cart, sections) {
    const id = sections.find((section) => /cart-drawer/.test(section));
    if (!id || !cart.sections || !cart.sections[id]) return () => {};
    const doc = new DOMParser().parseFromString(cart.sections[id], 'text/html');
    const box = doc.querySelector('.additional-checkout-buttons');
    if (!box || !box.innerHTML.trim() || box.querySelector('script')) return () => {};
    const wallets = box.innerHTML;
    const live = document.querySelector('cart-drawer .additional-checkout-buttons');
    const height = live ? Math.round(live.getBoundingClientRect().height) : 0;
    box.innerHTML = '';
    box.setAttribute('data-ae-wallets', 'held');
    if (height) box.setAttribute('style', 'min-height:' + height + 'px');
    cart.sections[id] = doc.body.innerHTML;
    return () => requestAnimationFrame(() => requestAnimationFrame(() => {
      const target = document.querySelector('cart-drawer .additional-checkout-buttons[data-ae-wallets="held"]');
      if (!target) return;
      target.innerHTML = wallets;
      target.removeAttribute('data-ae-wallets');
      target.style.minHeight = '';
    }));
  }

  async function request(url, options, limit) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), limit);
    try {
      const response = await fetch(url, Object.assign({}, options, { signal: controller.signal }));
      const json = await response.json();
      return { response, json };
    } finally {
      clearTimeout(timer);
    }
  }

  const getCart = () => request(root() + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }, 5000).then(({ json }) => (knownCart = json));
  const quantityOf = (cart, id) => ((cart && cart.items) || []).reduce((n, item) => n + (String(item.variant_id) === String(id) ? item.quantity : 0), 0);

  document.addEventListener('cart:change', (event) => { if (event.detail && event.detail.cart) knownCart = event.detail.cart; });
  window.addEventListener('load', () => setTimeout(() => {
    if (document.querySelector('product-form')) getCart().catch(() => {});
  }, 2500), { once: true });
  window.addEventListener('pageshow', (event) => { if (event.persisted) getCart().catch(() => {}); });

  async function landed(id, before) {
    try {
      const after = quantityOf(await getCart(), id);
      return before === null ? after > 0 : after > before;
    } catch (error) {
      return false;
    }
  }

  function setBusy(buttons, busy) {
    buttons.forEach((button) => {
      if (busy) {
        button.setAttribute('aria-busy', 'true');
        if (button.aeLabel === undefined) button.aeLabel = button.innerHTML;
        button.textContent = LABEL;
      } else {
        button.removeAttribute('aria-busy');
        if (button.aeLabel !== undefined) button.innerHTML = button.aeLabel;
        button.aeLabel = undefined;
      }
    });
  }

  function freezeMeter() {
    let last = now();
    let total = 0;
    let worst = 0;
    const id = setInterval(() => {
      const gap = now() - last - 100;
      if (gap > 50) { total += gap; worst = Math.max(worst, gap); }
      last = now();
    }, 100);
    return () => { clearInterval(id); return { total: round(total), worst: round(worst) }; };
  }

  function report(record) {
    record.total = round(now() - record.start);
    if (record.total < SLOW && record.outcome === 'added') return;
    const entry = performance.getEntriesByType('resource').filter((e) => /\/cart\/add/.test(e.name)).pop();
    if (entry) {
      record.addRequest = {
        queued: entry.requestStart ? round(entry.requestStart - entry.startTime) : null,
        server: entry.responseStart && entry.requestStart ? round(entry.responseStart - entry.requestStart) : null,
        download: entry.responseStart ? round(entry.responseEnd - entry.responseStart) : null,
        protocol: entry.nextHopProtocol || null
      };
    }
    record.pageAgeAtClick = round(record.start);
    record.browser = navigator.userAgent;
    console.error('[Aelse add to bag] ' + record.outcome + ' after ' + (record.total / 1000).toFixed(1) + ' s ' + JSON.stringify(record));

    // Hotjar's console tab is a paid feature on this account; event names show on any recording, so they carry the cause.
    const at = (name) => (record.steps.find((s) => s.step === name) || {}).at;
    const addTook = at('add') !== undefined ? at('add') : at('add-no-answer');
    const bagTook = at('bag') !== undefined && addTook !== undefined ? at('bag') - addTook : undefined;
    const events = ['ae_add_to_bag_' + record.outcome.replace(/-/g, '_')];
    if (addTook > SLOW) events.push('ae_add_to_bag_slow_add');
    if (bagTook > SLOW) events.push('ae_add_to_bag_slow_bag');
    if (record.addRequest && record.addRequest.queued > 2000) events.push('ae_add_to_bag_request_queued');
    if (record.freeze && record.freeze.worst > 1000) events.push('ae_add_to_bag_page_frozen');
    if (record.repeatClicks > 0) events.push('ae_add_to_bag_clicked_again');
    try {
      if (window.hj) events.forEach((name) => window.hj('event', name));
    } catch (error) {}
  }

  async function addToBag(form, buttons) {
    const record = { start: now(), outcome: 'added', steps: [] };
    const step = (name, extra) => record.steps.push(Object.assign({ step: name, at: round(now() - record.start) }, extra));
    const stopMeter = freezeMeter();
    const html = document.documentElement;
    const add = (body) => request(root() + 'cart/add.js', { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } }, LIMIT);

    form.aeBusy = true;
    form.aeRepeats = 0;
    setBusy(buttons, true);
    html.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    const sections = [];
    html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const body = new FormData(form);
    const variantId = body.get('id');
    const drawer = openBagEarly(form, variantId);
    if (drawer) step('bag-opened');
    // The drawer is rendered inside the add, as theme.js does: a separate GET of the section came back stale (empty bag,
    // her test 2026-10-14 19:43).
    body.set('sections', sections.join(','));
    body.set('sections_url', root() + 'variants/' + variantId);
    const before = knownCart ? quantityOf(knownCart, variantId) : null;
    let result = null;

    const finish = () => {
      form.aeBusy = false;
      setBusy(buttons, false);
      html.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      record.freeze = stopMeter();
      record.repeatClicks = form.aeRepeats;
      report(record);
    };

    try {
      result = await add(body);
      step('add', { status: result.response.status });
    } catch (error) {
      step('add-no-answer', { error: String((error && error.name) || error) });
      if (await landed(variantId, before)) {
        record.outcome = 'added-found-in-bag';
        finish();
        window.location.href = root() + 'cart';
        return;
      } else {
        // Not in the bag: hand the same form to Shopify as a plain page post (a different route from the stalled one),
        // which adds the item and opens the cart page.
        record.outcome = 'sent-plain-form';
        finish();
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
    }

    if (result && !result.response.ok) {
      record.outcome = 'shopify-refused';
      step('refused', { message: result.json && result.json.description });
      settleBag(drawer, false);
      finish();
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: result.json && result.json.description } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    const settings = (window.themeVariables && themeVariables.settings) || {};
    if (settings.cartType === 'page' || settings.pageType === 'cart') {
      finish();
      window.location.href = root() + 'cart';
      return;
    }

    let cart;
    try {
      cart = (await request(root() + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }, LIMIT)).json;
      cart.sections = result.json.sections;
      knownCart = cart;
      step('bag');
    } catch (error) {
      step('bag-no-answer', { error: String((error && error.name) || error) });
      record.outcome = record.outcome === 'added' ? 'added-sent-to-cart-page' : record.outcome + '-sent-to-cart-page';
      finish();
      window.location.href = root() + 'cart';
      return;
    }

    const items = Object.prototype.hasOwnProperty.call(result.json, 'items') ? result.json.items : [result.json];
    const onSuccessDo = body.get('on_success');
    const putWalletsBack = holdWallets(cart, sections);
    finish();
    form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items, cart, onSuccessDo } }));
    html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo, cart } }));
    putWalletsBack();
    if (drawer) requestAnimationFrame(() => requestAnimationFrame(() => settleBag(drawer, true)));
  }

  // Capture phase on document runs before theme.js's own listener on the form. Marking the clicked button busy makes
  // theme.js skip this submit (its own guard); with no clicked button known, the event is stopped instead.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form') || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;

    const buttons = Array.from(form.elements).filter((element) => element.type === 'submit');
    if (form.aeBusy) {
      event.preventDefault();
      form.aeRepeats += 1;
      if (!event.submitter) event.stopImmediatePropagation();
      return;
    }

    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.disabled) idInput.disabled = false;
    if (!form.checkValidity()) return;

    event.preventDefault();
    setBusy(buttons, true);
    if (!event.submitter || event.submitter.getAttribute('aria-busy') !== 'true') event.stopImmediatePropagation();
    addToBag(form, buttons);
  }, true);
})();
